<template lang="pug">
  .challenge-include-members
    BCollapse.card(
      aria-id="membersTable"
      :open.sync="open"
    )
      .card-header(
        slot='trigger',
        role='button',
        aria-controls='membersTable'
      )
        .card-header-title
          | {{ title }}
          WtTooltip(
            v-if="tooltipText"
            :text="tooltipText"
            position="is-right"
          )
        a.card-header-icon
          BIcon(:icon="open ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
      .card-content
        .members-tables
          MembersTable(
            :key="includeByType"
            :loading="!loaded"
            mode="api"
            :enable-search="true"
            @search="$emit('search', $event)"
            :enable-add="true"
            title="All Members:"
            :empty-message="loaded && 'Awaiting members ...' || ''"
            :includeByType="includeByType"
            :notInChallengeId="notInChallengeId"
          )
          .level
          MembersTable.mt-6(
            mode="receiver"
            :enable-remove="true"
            :title="receiverTitle"
            :empty-message="loaded && 'Awaiting members ...' || ''"
          )
</template>

<script>
import WtTooltip from "@@/WtTooltip/WtTooltip";
import MembersTable from "@@/Members/MembersTable";

export default {
  name: "ChallengeIncludeMembers",

  components: { WtTooltip, MembersTable },

  props: {
    openToggle: {
      type: Boolean,
      required: true
    },

    loaded: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      default: "Invite Members"
    },

    tooltipText: {
      type: String,
      default: ""
    },

    includeByType: {
      type: String,
      default: "invite"
    },

    notInChallengeId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      open: this.openToggle
    };
  },

  computed: {
    receiverTitle() {
      const textByType = {
        invite: "Members To Be Invited",
        add: "Members To Be Added"
      };

      return this._.get(textByType, this.includeByType, "Future Members");
    }
  },

  watch: {
    open() {
      this.$emit("toggle", this.open);
    },

    openToggle() {
      return (this.open = this.openToggle);
    }
  }
};
</script>

<style scoped lang="sass">
.challenge-invite-members
  .members-tables
    width: 100%
    min-height: 550px
</style>
